import { fetchApi, FetchResponse } from "../dataAccess";
import { PagedCollection } from "types/collection";
import { Form } from "types/form/Form";
import { IdOutput } from "types/IdOutput";

export class SaveOutput extends IdOutput {

}

const getFormsPath = (page?: string | string[] | undefined) =>
  `/api/forms${typeof page === "string" ? `?page=${page}` : ""}`;

const getForms = (page?: string | string[] | undefined, session?: any) =>
  async () => await fetchApi<PagedCollection<Form>>(getFormsPath(page), { cache: "no-cache" }, session);

const getItemPath = (id?: string | string[] | undefined) => `/api/forms/${id}`;

const getItem = (id: string, session: any) =>
  async () => await fetchApi<FetchResponse<Form> | undefined>(getItemPath(id), { cache: "no-cache" }, session);

const save = async (values: Form, session: any) =>
  await fetchApi<SaveOutput>(!values["@id"] ? "/api/forms" : values["@id"], {
    method: !values["@id"] ? "POST" : "PATCH",
    body: JSON.stringify(values),
  }, session);

export default { getItem, getItemPath, getFormsPath, getForms, save };